import { match } from "@formatjs/intl-localematcher";
import { LocaleProvider } from "@obs/components";

import { App } from "../App";
import { AccountProvider as ObsAccountProvider } from "../Components/Account/AccountProvider";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "../constants";
import type { SupportedLocale } from "../types/types";

export const AccountProvider = () => {
	const DEFAULT_PRIMARY_LOCALE: SupportedLocale = match(
		Array.from(navigator.languages),
		SUPPORTED_LOCALES,
		DEFAULT_LOCALE,
	) as SupportedLocale;
	return (
		<ObsAccountProvider>
			<LocaleProvider defaultLocale={DEFAULT_PRIMARY_LOCALE} supportedLocales={Array.from(SUPPORTED_LOCALES)}>
				<App />
			</LocaleProvider>
		</ObsAccountProvider>
	);
};
